import "graphiql/graphiql.css";

import { createGraphiQLFetcher } from "@graphiql/toolkit";
import { createFileRoute } from "@tanstack/react-router";
import { GraphiQL } from "graphiql";
import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useCustomer } from "shared/graphql/cust";
import { useOIDCStore } from "shared/stores/oidc";

const fetcher = createGraphiQLFetcher({
    url: import.meta.env["VITE_API_BASE_URL"] + "/graphql",
});

const component = () => {
    const auth = useAuth();
    const { getAccessToken } = useOIDCStore();
    const [token, setToken] = useState(getAccessToken());
    const customer = useCustomer().data;

    useEffect(() => {
        function handle() {
            setToken(getAccessToken());
        }

        auth.events.addAccessTokenExpiring(handle);
        return () => {
            auth.events.removeAccessTokenExpired(handle);
        };
    }, []);

    return (
        <GraphiQL
            fetcher={fetcher}
            headers={JSON.stringify({ Authorization: "Bearer " + token })}
            variables={JSON.stringify({ customerId: customer.id, subDomain: customer.subdomain })}
            defaultEditorToolsVisibility={"headers"}
        />
    );
};

/** @public */
export const Route = createFileRoute("/_auth/_dev/devtools/gql")({
    component,
});
